<ng-template #template>
  <div class="container">
    <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">
      <div class="row px-0 py-5" style="min-height: 800px">
        <div class="p-lg-0 col-lg-12">
          <div class="card h-100">
            <div class="card-body table-responsive-md">
              <h3 style="margin-bottom: 0; margin-top: 15px">
                <span>{{ texts.joinTeam }}</span>
              </h3>

              <span *ngIf="errorMessage" style="color: red">
                {{ errorMessage }}
              </span>
              <div class="container row my-4">
                <div class="col-lg-9 col-md-9 col-s-12 col-xs-12">
                  <span *ngIf="operation === 'create'">{{
                    texts.joinTeamHelp
                  }}</span>
                  <span *ngIf="operation === 'update'">{{
                    texts.confirmByLogin
                  }}</span>
                  <br /><br />
                  <div class="form-group">
                    <label for="txtUsername">{{ texts.userName }}</label>
                    <span
                      *ngIf="
                        (userName.dirty || userName.touched) &&
                        userName.invalid &&
                        userName.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.userNameRequired }}
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      id="txtUsername"
                      formControlName="userName"
                      placeholder="{{ texts.userName }}"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (userName.dirty || userName.touched) &&
                        userName.invalid &&
                        userName.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtPassword">{{ texts.password }}</label>
                    <span
                      *ngIf="
                        (password.dirty || password.touched) &&
                        password.invalid &&
                        password.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.passwordRequired }}
                    </span>
                    <input
                      type="password"
                      class="form-control"
                      id="txtPassword"
                      formControlName="password"
                      placeholder="{{ texts.password }}"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (password.dirty || password.touched) &&
                        password.invalid &&
                        password.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtFirstName">{{ texts.firstName }}</label>
                    <span
                      *ngIf="
                        (firstName.dirty || firstName.touched) &&
                        firstName.invalid &&
                        firstName.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.firstNameRequired }}
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      id="txtFirstName"
                      formControlName="firstName"
                      placeholder="{{ texts.firstName }}"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (firstName.dirty || firstName.touched) &&
                        firstName.invalid &&
                        firstName.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtLastName">{{ texts.lastName }}</label>
                    <span
                      *ngIf="
                        (lastName.dirty || lastName.touched) &&
                        lastName.invalid &&
                        lastName.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.lastNameRequired }}
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      id="txtLastName"
                      formControlName="lastName"
                      placeholder="{{ texts.lastName }}"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (lastName.dirty || lastName.touched) &&
                        lastName.invalid &&
                        lastName.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtUniversityId">{{
                      texts.universityId
                    }}</label>
                    <span
                      *ngIf="
                        (universityId.dirty || universityId.touched) &&
                        universityId.invalid &&
                        universityId.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.universityIdRequired }}
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      id="txtUniversityId"
                      formControlName="universityId"
                      placeholder="{{ texts.universityId }}"
                      required
                      maxlength="10"
                      [class.is-invalid]="
                        (universityId.dirty || universityId.touched) &&
                        universityId.invalid &&
                        universityId.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtEmail">{{ texts.email }}</label>
                    <span
                      *ngIf="
                        (email.dirty || email.touched) &&
                        email.invalid &&
                        email.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.emailRequired }}
                    </span>
                    <span
                      *ngIf="
                        (email.dirty || email.touched) &&
                        email.invalid &&
                        email.errors.email
                      "
                      style="color: red"
                    >
                      {{ texts.emailInvalid }}
                    </span>
                    <input
                      type="email"
                      class="form-control"
                      id="txtEmail"
                      formControlName="email"
                      placeholder="{{ texts.email }}"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (email.dirty || email.touched) &&
                        email.invalid &&
                        (email.errors.required || email.errors.email)
                      "
                    />
                  </div>

                  <a
                    class="btn font-btn-small text-uppercase btn-outline-secondary mr-2 my-2"
                    (click)="cancel()"
                    >{{ texts.cancel }}</a
                  >

                  <button
                    class="btn font-btn-small text-uppercase btn-primary ml-2 my-2"
                    [disabled]="!memberForm.valid"
                    [ngClass]="cssColor + '-inv'"
                    type="submit"
                  >
                    <span *ngIf="operation === 'create'">{{ texts.join }}</span>
                    <span *ngIf="operation === 'update'">{{
                      texts.update
                    }}</span>
                  </button>
                </div>
                <div class="col-lg-3 col-md-3 col-s-12 col-xs-12">
                  <div class="card text-center" style="width: 18rem">
                    <div
                      class="card-img-top"
                      style="
                        height: 250px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <img
                        [src]="preview"
                        [alt]="memberForm.value.name"
                        *ngIf="preview && preview !== null"
                        style="
                          width: auto;
                          max-width: 200px;
                          max-height: 200px;
                          margin: 0 auto;
                        "
                      />
                      <img
                        [src]="current | authImage | async"
                        [alt]="memberForm.value.name"
                        *ngIf="current && current !== null"
                        style="
                          width: auto;
                          max-width: 200px;
                          max-height: 200px;
                          margin: 0 auto;
                        "
                      />
                    </div>
                  </div>
                  <span *ngIf="tooLargeFile" style="color: red">
                    {{ texts.fileTooLarge }}
                  </span>

                  <div class="form-group">
                    <label for="txtEmail">{{ texts.picture }} (max 2 Mb)</label>
                    <input type="file" (change)="uploadFile($event)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
